import { Box, Typography } from "@mui/material";

export default function AgentAnalytics() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Analyse globale</Typography>
      <Typography color="text.secondary">
        Statistiques consolidées sur les agents IA.
      </Typography>
    </Box>
  );
}
